/* @ngInject */
export default function Form() {
  return {
    restrict: 'E',
    link(scope, elem, attrs) {
      elem.attr('novalidate', 'novalidate');
    },
  };
}
